export default __webpack_public_path__ + "static/media/camera.b3d26684.svg";